import React, { useEffect, useState } from "react";
import "./ecomsellerdetails.scss";
import checkmark from "../../../images/checkmark 1.svg";
import line from "../../../images/Line 1.png";
import contact from "../../../images/driver-license (1) 1.png";
import coin from "../../../images/coin 1.png";
import advertisement from "../../../images/megaphone 1.png";
import scooter from "../../../images/scooter 1.png";
import cost from "../../../images/cost 1.png";
import rto from "../../../images/product-return 1.png";
import donation from "../../../images/donation 1.png";
import SellerNavbar from "../../../components/SellerNavbar";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
const baseUrl = process.env.REACT_APP_BASEURL;
const EcomSellerDetails = () => {
  const [accountholdername, setAccountholdername] = useState("");
  const [ifsccode, setIfsccode] = useState("");
  const [gstin, setGstin] = useState("");
  const [aadhar, setAadhar] = useState("");
  const [pannumber, setPannumber] = useState("");
  const [accountnumber, setAccountnumber] = useState("");
  const [fullname, setFullname] = useState("");
  const [storename, setStorename] = useState("");
  const [storeaddress, setStoreaddress] = useState("");
  const [storepincode, setStorepincode] = useState("");
  const [image, setImage] = useState("");
  const [image1, setImage1] = useState("");
  const navigate = useNavigate();
  console.log(accountholdername, "kk");
  // Get user from store
  const state = useSelector((state) => state.sellers);
  const { sellerregisterAuth } = state;
  console.log(sellerregisterAuth, "ll");
  
useEffect(()=>{
  const item = localStorage.getItem('phoneNumber');
  console.log(item,'item');
  setImage(item)
},[]);
useEffect(()=>{
  const item = localStorage.getItem('sellerregisterInfo');
  console.log(item,'sellerregisterInfo');

  setImage1(JSON.parse(item))
},[]);


console.log(image1?.phoneNumber,'image1');
  console.log(aadhar, gstin, sellerregisterAuth?.phoneNumber, "ggg");
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      const accountholdername =
        document.getElementById("accountholdername").value;
      const ifsccode = document.getElementById("IFSC").value;
      const accountnumber = document.getElementById("accountnumber").value;
      const fullname = document.getElementById("fullname").value;
      const storename = document.getElementById("storename").value;
      const storeaddress = document.getElementById("storeaddress").value;
      const storepincode = document.getElementById("storepincode").value;
      const pannumber = document.getElementById("pannumber").value;

      const aadhar1 = document.getElementById("aadhar").value;
      const gstin1 = document.getElementById("gstin").value;
      console.log(ifsccode, "ifsccodegggg");
      formData.append("Accountholdername", accountholdername);
      formData.append("IFSC", ifsccode);
      formData.append("aadhar", aadhar1);
      formData.append("gstin", gstin1);
      formData.append("panNumber", pannumber);
      formData.append("Fullname", fullname);
      formData.append("Accountnumber", accountnumber);
      formData.append("Storename", storename);
      formData.append("Storeaddress", storeaddress);
      formData.append("Storepincode", storepincode);

      formData.append("phoneNumber", image1?.phoneNumber);
      formData.append("reseller", image1?._id);
      console.log(formData, "formdata");
      const response = await axios.post(
        `${baseUrl}/api/reseller/resellerdetails`,
        {
          Accountholdername: accountholdername,
          IFSC: ifsccode,
          aadhar: aadhar,
          gstin: gstin,
          panNumber: pannumber,
          Fullname: fullname,
          Accountnumber: accountnumber,
          Storename: storename,
          Storeaddress: storeaddress,
          Storepincode: storepincode,
          phoneNumber: image1?.phoneNumber,
          reseller: image1?._id,
        },

        {
          headers: {
            Authorization: `Bearer ${image1?.token}`,
          },
        }
      );
      localStorage.setItem("details",response?.data);

      const response1 = await axios.post(
        `${baseUrl}/api/reseller/updatesellertype`,
        {
          phoneNumber:image1?.phoneNumber
        })
      toast.success("Details send successfully");
      localStorage.removeItem("sellerregisterInfo");
      localStorage.removeItem("phoneNumber");
      navigate("/confirmation");
      console.log(response.data, "vhhhhhhhhhhh");
    } catch (error) {
      console.error(error);
      toast.error("Error");
    }
  };

  return (
    <div>
      <ToastContainer />
      <SellerNavbar />
      <div className="sellerregistercontainer">
        <div className="detailsmaindiv">
          <p className="hellotheretext">Hello There</p>
          <div className="mobileverificationdiv">
            <p className="mobileverificationtext">
              Your Mobile Number +91{image1?.phoneNumber}
              Has Been Verified
            </p>
            <img src={checkmark} />
          </div>
          {/* <img src={line} className="firstseparationline" /> */}
          <div className="sellerverticaldiv">
            <p className="aadharandpanselltext">
            Your Aadhaar & Pan GST Required to Sell on Onstara<span className="regredstar">*</span>
            </p>
            <p className="enterbankaccountdetailstext">
              Enter Your Bank Account Details <span className="regredstar">*</span>{" "}
            </p>
          </div>
          <form onSubmit={handleSubmit} className="sellerdetailsform">
            <div className="sellerdetailsfirstinnerdiv">
              <div className="aadharandpandiv">
                <input
                  className="sellerdetailsinput"
                  id="gstin"
                  placeholder="Enter GSTIN Number"
                  value={gstin}
                  onChange={(event) => setGstin(event.target.value)}
                />
                <input
                  className="sellerdetailsinput"
                  placeholder="Enter Aadaar Number"
                  id="aadhar"
                  type="Number"
                  value={aadhar}
                  onChange={(event) => setAadhar(event.target.value)}
                />
                <input
                  className="sellerdetailsinput"
                  placeholder="Enter Pan Number"
                  id="pannumber"
                  value={pannumber}
                  onChange={(event) => setPannumber(event.target.value)}
                />
              </div>

              <div className="bankdetailsdiv">
                <div className="bankdetailsdivinner">
                  <input
                    className="sellerdetailsinputOne"
                    id="accountholdername"
                    placeholder="Accountholder Name"
                    value={accountholdername}
                    onChange={(event) =>
                      setAccountholdername(event.target.value)
                    }
                  />
                  <input
                    className="sellerdetailsinputtwo"
                    placeholder="IFSC code"
                    id="IFSC"
                    value={ifsccode}
                    onChange={(event) => setIfsccode(event.target.value)}
                  />
                </div>
                <input
                  className="sellerdetailsinputthree"
                  id="accountnumber"
                  placeholder="Account Number"
                  value={accountnumber}
                  onChange={(event) => setAccountnumber(event.target.value)}
                />
              </div>
            </div>

            {/* <img src={line} className="firstseparationline" /> */}
            <p className="storeandpickupdetails">Store & Pickup Detials</p>

            <div style={{ display: "flex" }}>
              <div className="aadharandpandiv">
                <input
                  className="sellerdetailsinputfour"
                  id="fullname"
                  placeholder="Fullname"
                  value={fullname}
                  onChange={(event) => setFullname(event.target.value)}
                />
                <input
                  className="sellerdetailsinputfive"
                  id="storeaddress"
                  placeholder="Store Address"
                  value={storeaddress}
                  onChange={(event) => setStoreaddress(event.target.value)}
                />
              </div>
              <div className="bankdetailsdiv">
                <input
                  className="sellerdetailsinputsix"
                  id="storename"
                  placeholder="Store Name"
                  value={storename}
                  onChange={(event) => setStorename(event.target.value)}
                />
                <input
                  className="sellerdetailsinputseven"
                  id="storepincode"
                  placeholder="Store Pincode"
                  value={storepincode}
                  onChange={(event) => setStorepincode(event.target.value)}
                />
              </div>
            </div>
            <button className="sendforreview">Send For Review</button>
          </form>
        </div>
        <div>
          <div style={{ display: "flex" }}>
            <div className="onstarafeesdiv">
              <div style={{ display: "flex" }}>
                <img src={coin} className="coinimage" />
                <p className="onstarafeestext">Onstara Fees</p>
              </div>
              <p className="productbasedfees">Product Category Based Fees</p>
              <p className="productbasedfeesinterest">
                Start @ 1% varies based on product
              </p>
            </div>
            <div className="fixedfeesdiv">
              <div style={{ display: "flex" }}>
                <img src={donation} className="donationimage" />
                <p className="fixedfeetext">Fixed Fee</p>
              </div>
              <p className="basedonitemprice">Based On Item Price</p>
              <p className="basedonitempriceinterest">
                Start at ₹3 varies by product range
              </p>
            </div>
          </div>
          <div>
            <div style={{ display: "flex" }}>
              <div className="shippingfeesdiv">
                <div style={{ display: "flex" }}>
                  <img src={scooter} className="scooterimage" />
                  <p className="shippingfeestext">Shipping Fees</p>
                </div>
                <p className="feeforsingleproducttext">
                  Fee for single product shipping
                </p>
                <p className="feeforsingleproductinterest">
                  Start at ₹27/item price may varies by volume & distance of
                  shipment
                </p>
              </div>
              <div className="packingfeediv">
                <div style={{ display: "flex" }}>
                  <img src={cost} className="costimage" />
                  <p className="packingfeetext">Packing Fee</p>
                </div>
                <p className="feeforpackingmaterialtext">
                  Fee for Packaging Materials
                </p>
                <p className="feeforpackingmaterialinteresttext">
                  Free packing & other materials (Depends on time period)
                </p>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div className="advertisementfeediv">
                <div style={{ display: "flex" }}>
                  <img src={advertisement} className="advertisementimage" />
                  <p className="advertisementfeetext">Advertisement Fee</p>
                </div>
                <p className="feeforadvertisementtext">Fee for Advertisement</p>
                <p className="freeadvertisementforshorttime">
                  Free advertisement cost
                </p>
                <p className="freeadvertisementforshorttimetext">
                  (For short time period)
                </p>
              </div>
              <div className="rtochargediv">
                <div style={{ display: "flex" }}>
                  <img src={rto} className="rtoimage" />
                  <p className="rtochargetext">RTO CHARGE</p>
                </div>
                <p className="feeforrtotext">Fee For RTO</p>
                <p className="rtochargeinteresttext">
                  0 - 25% of returns taken by Onstara based on timely reasons of
                  RTO Charge
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EcomSellerDetails;
